import { useRef, useState, useMemo } from 'react';
import { Card, Stack } from '@mui/material';
import { usePageView } from 'src/hooks/use-page-view';
import ListSearch from 'src/components/ui/search/list-search';
import { ListTree } from './list-tree';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import { appStr } from 'src/locales/app_strings';
import { useRouter } from 'src/hooks/use-router';
import { nextNavigate } from 'src/utils/navigation-utils';
import { paths } from 'src/paths';
import TitleButton from 'src/components/ui/headers/title-button';
import PageSection from 'src/layouts/page-section';

const Page = ({ dataSearch, dataStore }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);

  usePageView();

  const labels = useMemo(
    () => ({
      both: { short: 'name', full: t(appStr.txt_061) },
    }),
    [t]
  );

  const [data, setData] = useState(null);
  const [prevData, setPrevData] = useState([]); // Back data
  const [disable, setDisable] = useState(true);

  const router = useRouter();
  const handleCreate = () => {
    if (prevData.length > 0) {
      dataSearch.state.filters.query = {
        ...dataSearch.state.filters.query, // Keep existing query data
        ids: prevData, // Add new data
      };
    }
    nextNavigate(
      router,
      dataSearch.state,
      paths.groups.details,
      paths.groups.index,
      data,
    );
  };

  const handleItemClicked = (itemId, label, leaf) => {
    setDisable(false);

    const json = {};
    json.leaf = leaf;
    json.id = itemId;
    json.name = label;

    setData(json);
  };

  const handleItemExpansion = (itemId, isExpanded) => {
    setPrevData((prevData) => {
      if (isExpanded) {
        // Add itemId if it doesn't exist in the array
        return prevData.includes(itemId) ? prevData : [...prevData, itemId];
      } else {
        // Remove itemId if it exists in the array
        return prevData.filter((id) => id !== itemId);
      }
    });
  };

  return (
    <PageSection title="Groups" rootRef={rootRef}>
      <Stack spacing={1}>
        <TitleButton
          label={t(tokens.nav.groups)}
          onButtonClick={handleCreate}
          disableButton={disable}
        />

        <Card>
          <ListSearch
            onFiltersChange={dataSearch.handleFiltersChange}
            filtersQuery={dataSearch.state.filters.query}
            placeholder={'both'}
            filterLabels={labels}
            disable={true}
          />
          <ListTree
            items={dataStore.items}
            defaultItem={dataSearch.state.filters.query?.ids}
            onItemClicked={handleItemClicked}
            onItemExpansion={handleItemExpansion}
            // onEditedItem={handleEditedItem}
          />
        </Card>
      </Stack>
    </PageSection>
  );
};

export default Page;
